module.exports = __webpack_public_path__ + "img/LogoRegular.c21fd25d.svg";